import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { memo } from 'common/hocs/memo';
import { Card } from '../card';
import { Header, Size, Typography, TypographyProps } from '../typography';
import { SectionSubTitle, SectionSubTitleProps } from '../section-subtitle';

export const MediaCard = styled(Card)`
  padding: 0;
`;

export const CardMedia = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
`;

export const MediaCardContent = styled.div`
  width: 100%;
  padding: 16px 24px;

  @media (--to-desktop) {
    padding: 16px;
  }
`;

type MediaCardTitleProps = {
  variant?: Header;
} & Omit<SectionSubTitleProps, 'variant' | 'margin'>;

export const MediaCardTitle: React.FC<MediaCardTitleProps> = ({
  as = 'p',
  children,
  className,
  variant = 'h3',
  ...rest
}) => (
  <SectionSubTitle
    className={cn(className, mediaCardTitlestyle)}
    margin="s"
    variant={variant}
    as={as}
    {...rest}>
    {children}
  </SectionSubTitle>
);

export const mediaCardTitlestyle = css`
  margin-bottom: 8px;
`;

type MediaCardDescriptionProps = {
  size?: Size;
} & Omit<TypographyProps, 'variant' | 'size' | 'adaptiveProps'>;

export const MediaCardDescription = memo(
  ({ children, size = 'body_short', ...rest }: MediaCardDescriptionProps) => (
    <Typography variant="m" size={size} {...rest}>
      {children}
    </Typography>
  )
);
